import { render } from "./AktionButton.vue?vue&type=template&id=3dd907eb&scoped=true"
import script from "./AktionButton.vue?vue&type=script&lang=js"
export * from "./AktionButton.vue?vue&type=script&lang=js"

import "./AktionButton.vue?vue&type=style&index=0&id=3dd907eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd907eb"]])

export default __exports__